import Cookies from 'js-cookie'

import { Toast } from 'vant'
import { decryptCode, getQueryParam, createDeviceId } from '@/utils/common.js'
import { uploadCodePri } from '@/config/common.js'

export default {
  env: (function () {
    const ua = navigator.userAgent
    let env = {
      ua: ua,
      isApp: /dq/i.test(ua),
      isMobile: /android|iphone|ipod|ipad/i.test(ua),
      isIOS: /iphone|ipod|ipad/i.test(ua),
      isAndroid: /android/i.test(ua),
      isWechat: /micromessenger/i.test(ua),
      isQQ: /qq\//i.test(ua),
      isWeibo: /weibo/i.test(ua),
      isDingTalk: /dingtalk/i.test(ua)
    }
    env.isBrowser = !(env.isApp || env.isWechat || env.isQQ || env.isWeibo || env.isDingTalk)
    return env
  })(),

  // 判断语言-链接
  getLangFromUrl(url) {
    if (url.indexOf('lang') > 0) {
      let queryLang = url.substring(url.indexOf('lang='), url.indexOf('lang=') + 7)
      let urlLang = queryLang.substr(queryLang.indexOf('=') + 1)
      return urlLang
    }
    return 'en'
  },

  // 获得版本号码
  appVersion() {
    let AppInfo = this.getAppInfo()
    let app_version = AppInfo ? AppInfo['version'] : ''
    if (app_version) {
      app_version = app_version.replace(/\./g, '')
    }
    return app_version
  },

  // 获取包信息
  getAppInfo() {
    // app内
    if (this.env.isApp) {
      let appInfo = Cookies.get('UserInfo')
      return appInfo ? eval('(' + appInfo + ')') : {}
    }
    // 非app内
    else {
      let deviceId = ''
      let appPackageName = ''
      let channel = 'vvg'

      // 浏览器环境 仅为sayHi活动-浏览器登陆状态 使用
      if (this.env.isBrowser) {
        try {
          let da = getQueryParam(window.location.href, 'da')
          da = decodeURIComponent(da)
          let strObj = decryptCode(da, uploadCodePri)
          if (strObj) {
            strObj = JSON.parse(strObj)
          }
          if (strObj) {
            deviceId = strObj.deviceId
            appPackageName = strObj.appPackageName
          }

          // 为签名用(没有的话随机生成一个)
          if (!deviceId) {
            deviceId = createDeviceId()
          }
        } catch (err) {
          console.log('try catch', err)
        }
      }

      // localhsot-调试
      if (window.location.hostname === 'localhost') {
        appPackageName = 'com.example.gcc'
        deviceId = '9b7cdeac-9ea6-4467-b9c9-d94bdc690d4d'
      }

      return {
        language: this.getLangFromUrl(window.location.hash),
        channel: channel,
        appPackageName: appPackageName,
        deviceId: deviceId
      }
    }
  },

  // 获取用户id和token
  getUserBaseInfo() {
    // app内
    if (this.env.isApp) {
      let uid = '',
        token = ''
      let userInfo = Cookies.get('UserInfo')
      if (userInfo) {
        userInfo = eval('(' + userInfo + ')')
        uid = userInfo['uid']
        token = userInfo['token']
      }
      return {
        uid: uid,
        token: token
      }
    }
    // 非app内
    else {
      // 好友
      // 1079 -> 2507

      let uid = ''
      let token = ''

      if (this.env.isBrowser) {
        try {
          let ut = getQueryParam(window.location.href, 'ut')
          ut = decodeURIComponent(ut)
          let strObj = decryptCode(ut, uploadCodePri)
          if (strObj) {
            strObj = JSON.parse(strObj)
          }
          if (strObj) {
            uid = strObj.uid
            token = strObj.token
          }
        } catch (err) {
          console.log('try catch', err)
        }
      }

      // localhsot-调试代码
      if (window.location.hostname === 'localhost') {
        uid = '1079'
        token = 'be967333dc1b4776aded5d062ca76040'
      }

      return {
        uid: uid,
        token: token
      }
    }
  },

  // 获取包信息中的语言 优先取appLanguage 如果值为auto 则取另外一个值language
  getAppInfoLang() {
    // app内
    if (this.env.isApp) {
      let appInfo = Cookies.get('UserInfo')
      let obj = appInfo ? eval('(' + appInfo + ')') : null
      if (obj !== null && Object.keys(obj).length > 0) {
        if (obj.appLanguage) {
          return obj.appLanguage == 'auto' ? obj.language : obj.appLanguage
        }
        return obj.language
      }
    }
    // 非app内
    else {
      return this.getLangFromUrl(window.location.hash)
    }
  },

  // 提示消息
  showToast(message) {
    try {
      // app内
      if (this.env.isApp) {
        showToast.postMessage(message)
      }
      // 非app内
      else {
        Toast(message)
      }
    } catch (err) {
      console.log('try catch', err)
    }
  },

  //关闭webview
  closeActivity() {
    closeActivity.postMessage('')
  },

  // 关闭iOS页面
  closeActivityIOS() {
    window.webkit.messageHandlers.closeActivity.postMessage(null)
  },

  // 埋点
  addEvent(event, param) {
    try {
      if (this.env.isApp) {
        let params = {
          eventName: event,
          param: param
        }
        addEvent.postMessage(JSON.stringify(params))
      }
    } catch (err) {
      console.log('try catch', err)
    }
  },

  // 给客户端传参数 判断google支付 vava
  googleProductList(list) {
    try {
      queryGoogleProductList.postMessage(JSON.stringify(list))
    } catch (err) {
      console.log('try catch', err)
    }
  },

  // 给客户端传参数 判断apple-pay支付 echo
  applePayProductList(list) {
    try {
      queryProductList.postMessage(JSON.stringify(list))
    } catch (err) {
      console.log('try catch', err)
    }
  },

  // 拷贝链接
  copyLink(link, msg) {
    Vue.prototype.$copyText(link).then((e) => {
      if (e) {
        if (msg) {
          this.showToast(msg)
        }
      }
    })
  }
}
